import { CatGrid } from '@blocks-react/components/Grid';
import { CatGridItem } from '@blocks-react/components/GridItem';
import ContactInformationText from './Guest-Input-Form-Text';
import { FORM_NAMES, FORM_LABELS, INPUTS_MAX_LENGTH } from '../constants';
import { getFormRules } from './utils';
import PhoneInput from './Guest-Phone-Input';
import { FormFieldsProps } from './types';
import { useFormContext } from 'react-hook-form';

const ContactInformation = ({ countries, t }: FormFieldsProps) => {
  const formRules = getFormRules(t);
  const {
    formState: { isSubmitting, errors }
  } = useFormContext();

  return (
    <>
      <p className="cat-u-theme-typography-label-lg u-color--Black mt-3">
        {t('ORG_CONTACT_INFO')}
      </p>
      <CatGrid gap="xs">
        <CatGridItem>
          <ContactInformationText
            name={FORM_NAMES.FIRST_NAME}
            disabled={isSubmitting}
            label={t(FORM_LABELS[FORM_NAMES.FIRST_NAME])}
            maxlength={INPUTS_MAX_LENGTH.firstName}
            error={errors?.firstName}
            required
            t={t}
            rules={formRules[FORM_NAMES.FIRST_NAME]}
          />
        </CatGridItem>
        <CatGridItem>
          <ContactInformationText
            name={FORM_NAMES.LAST_NAME}
            disabled={isSubmitting}
            label={t(FORM_LABELS[FORM_NAMES.LAST_NAME])}
            error={errors?.lastName}
            maxlength={INPUTS_MAX_LENGTH.lastName}
            required
            t={t}
            rules={formRules[FORM_NAMES.LAST_NAME]}
          />
        </CatGridItem>
        <CatGridItem>
          <ContactInformationText
            disabled={isSubmitting}
            name={FORM_NAMES.EMAIL}
            label={t(FORM_LABELS[FORM_NAMES.EMAIL])}
            maxlength={INPUTS_MAX_LENGTH.email}
            required
            t={t}
            error={errors?.email}
            rules={formRules[FORM_NAMES.EMAIL]}
          />
        </CatGridItem>
        <CatGridItem>
          <PhoneInput
            disabled={isSubmitting}
            countries={countries}
            dropdownLabel={t(FORM_LABELS[FORM_NAMES.COUNTRY_CODE])}
            inputLabel={t(FORM_LABELS[FORM_NAMES.PHONE])}
            phoneError={errors?.phone}
            phoneRule={formRules[FORM_NAMES.PHONE]}
            t={t}
            required
          />
        </CatGridItem>
        <CatGridItem>
          <ContactInformationText
            disabled={isSubmitting}
            name={FORM_NAMES.COMPANY_NAME}
            label={t(FORM_LABELS[FORM_NAMES.COMPANY_NAME])}
            t={t}
            error={errors?.companyName}
            rules={formRules[FORM_NAMES.COMPANY_NAME]}
          />
        </CatGridItem>
      </CatGrid>
    </>
  );
};

export default ContactInformation;
